<div class="modal-body">
  <div
    class="v-center text-center d-flex flex-column align-items-center justify-content-center"
  >
    <img
      src="assets/images/virtusa-icons/caution-red.svg"
      alt="caution"
      width="50px"
      height="60px"
    />
    <span class="header-18"> {{ configs.title }} </span>
    <span class="accello-general-text5">
      {{ configs.subTitle }}
    </span>
  </div>

  <div class="d-flex flex-row w-100 justify-content-end mt-3">
    <button
      class="btn btn-accello-primary-light"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
  </div>
</div>
